import { usePagination as useAlgoliaPagination } from 'react-instantsearch';
import { MouseEvent } from 'react';

const PADDING = 3;

export const usePagination = ({
  onPageChange,
}: {
  onPageChange?: () => void;
}) => {
  const {
    currentRefinement: currentPage,
    pages,
    nbPages,
    isFirstPage,
    isLastPage,
    createURL,
    refine,
  } = useAlgoliaPagination({
    padding: PADDING,
  });

  const firstPage = 0;
  const previousPage = currentPage - 1;
  const nextPage = currentPage + 1;
  const lastPage = nbPages - 1;

  const displayPagination = nbPages > 1;

  const firstPageInRange = pages[0];
  const displayGoToFirstPage = firstPageInRange !== firstPage;
  const displayGoToFirstPageEllipsis = firstPageInRange !== firstPage + 1;

  const lastPageInRange = pages[pages.length - 1];
  const displayGoToLastPage = lastPageInRange !== lastPage;
  const displayGoToLastPageEllipsis = lastPageInRange !== lastPage - 1;

  const displayGoToPreviousPage = !isFirstPage;
  const displayGoToNextPage = !isLastPage;

  const loadPageResults = (
    event: MouseEvent<HTMLAnchorElement>,
    page: number,
  ) => {
    event.preventDefault();

    if (page === currentPage) {
      return;
    }

    refine(page);
    onPageChange?.();
  };

  return {
    createURL,
    loadPageResults,
    pages,
    currentPage,
    previousPage,
    nextPage,
    firstPage,
    lastPage,
    displayPagination,
    displayGoToFirstPage,
    displayGoToFirstPageEllipsis,
    displayGoToLastPage,
    displayGoToLastPageEllipsis,
    displayGoToPreviousPage,
    displayGoToNextPage,
  };
};
